// extracted by mini-css-extract-plugin
export var alt = "HotelCard-module--alt--a4c11";
export var brandLogo = "HotelCard-module--brandLogo--047b8";
export var buttonWrapper = "HotelCard-module--buttonWrapper--a1608";
export var card = "HotelCard-module--card--04b86";
export var carouselContainer = "HotelCard-module--carouselContainer--64f4b";
export var carouselIcon = "HotelCard-module--carouselIcon--94f8e";
export var carouselNextIcon = "HotelCard-module--carouselNextIcon--f1749";
export var carouselPrevIcon = "HotelCard-module--carouselPrevIcon--352a2";
export var chevronLeft = "HotelCard-module--chevronLeft--24382";
export var chevronRight = "HotelCard-module--chevronRight--cb33a";
export var container = "HotelCard-module--container--7d96e";
export var desktopOnly = "HotelCard-module--desktopOnly--8c66b";
export var hotelCardAmenitesWrapper = "HotelCard-module--hotelCardAmenitesWrapper--bbe7a";
export var hotelRoomUnlockButtonWapper = "HotelCard-module--hotelRoomUnlockButtonWapper--4028f";
export var imagePriceContainer = "HotelCard-module--imagePriceContainer--b5dd1";
export var imageWrapper = "HotelCard-module--image-wrapper--2b25d";
export var main = "HotelCard-module--main--54353";
export var memberRateLabel = "HotelCard-module--memberRateLabel--bcf7c";
export var mobileOnly = "HotelCard-module--mobileOnly--d326c";
export var mt45 = "HotelCard-module--mt-4-5--5670e";
export var swiper = "HotelCard-module--swiper--04bca";
export var swiperSlide = "HotelCard-module--swiper-slide--56b85";
export var textLeft = "HotelCard-module--textLeft--5252f";
export var title4 = "HotelCard-module--title4--060d9";
export var unlockButton = "HotelCard-module--unlockButton--ab7c5";
export var visuallyHidden = "HotelCard-module--visuallyHidden--690f2";